/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Previewer from "vux/src/components/previewer/index.vue";
export default {
  components: {
    Previewer: Previewer
  },
  props: {
    title: {
      type: String,
      default: '图片'
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    num: {
      type: Number,
      default: 9
    },
    hiddenBorder: {
      type: Boolean,
      default: false
    },
    onlyCamera: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      currValue: this.value,
      hasTitleSlot: false
    };
  },
  computed: {
    imgUrlsForPreviewer: function imgUrlsForPreviewer() {
      return this.currValue.map(function (item) {
        return {
          src: item
        };
      });
    }
  },
  watch: {
    value: function value(val) {
      this.currValue = val;
    },
    currValue: function currValue(val) {
      this.$emit('on-change', val);
      this.$emit('input', val);
    }
  },
  methods: {
    clickUpload: function clickUpload() {
      var _this = this;

      if (this.currValue.length === this.num) {
        this.$vux.toast.text("\u56FE\u7247\u6700\u591A".concat(this.num, "\u5F20"));
      } else {
        var max = this.num - this.currValue.length;
        var options = {
          compression: false,
          multiple: true,
          max: max,
          quality: 50,
          // 图片压缩质量,
          resize: 50,
          // 图片缩放率
          stickers: {},
          // 水印信息
          onSuccess: function onSuccess(result) {
            _this.currValue = _this.currValue.concat(result);
          },
          onFail: function onFail(e) {
            _this.$vux.toast.text('uploadImage error');
          }
        };
        this.$DingTalk.ready(function () {
          if (_this.onlyCamera) {
            _this.$DingTalk.biz.util.uploadImageFromCamera(options);
          } else {
            _this.$DingTalk.biz.util.uploadImage(options);
          }
        });
      }
    },
    deleteImg: function deleteImg(index) {
      this.currValue.splice(index, 1);
    },
    show: function show(index) {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$refs['previewer'].show(index);
      });
    }
  },
  mounted: function mounted() {
    this.$slots.title && (this.hasTitleSlot = true);
  }
};